// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Tab styles for the dashboard */
.tabs {
  display: flex;
  border-bottom: 1px solid #e5e7eb;
  margin-bottom: 1.5rem;
  background-color: #fff;
  border-radius: 8px 8px 0 0;
  overflow: hidden;
}

.tab-button {
  padding: 0.75rem 1.5rem;
  font-weight: 500;
  font-size: 0.95rem;
  background: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #6b7280;
  position: relative;
}

.tab-button:hover {
  color: #3b82f6;
  background-color: #f9fafb;
}

.tab-button.active {
  color: #3b82f6;
  background-color: #fff;
}

.tab-button.active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #3b82f6;
}

.tab-content {
  background-color: #fff;
  border-radius: 0 0 8px 8px;
  padding: 1.5rem;
}`, "",{"version":3,"sources":["webpack://./src/styles/tabs.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,aAAa;EACb,gCAAgC;EAChC,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;AACjB","sourcesContent":["/* Tab styles for the dashboard */\n.tabs {\n  display: flex;\n  border-bottom: 1px solid #e5e7eb;\n  margin-bottom: 1.5rem;\n  background-color: #fff;\n  border-radius: 8px 8px 0 0;\n  overflow: hidden;\n}\n\n.tab-button {\n  padding: 0.75rem 1.5rem;\n  font-weight: 500;\n  font-size: 0.95rem;\n  background: none;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: #6b7280;\n  position: relative;\n}\n\n.tab-button:hover {\n  color: #3b82f6;\n  background-color: #f9fafb;\n}\n\n.tab-button.active {\n  color: #3b82f6;\n  background-color: #fff;\n}\n\n.tab-button.active::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background-color: #3b82f6;\n}\n\n.tab-content {\n  background-color: #fff;\n  border-radius: 0 0 8px 8px;\n  padding: 1.5rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
